import React from "react";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import AlertsShipmentList from "./AlertsShipmentList";
import ShipmentFields from "./ShipmentFields";

const AlertsContent = ({ deviceid, shipmentid,setActiveTab,shipmentData }) => {
  return (
    <>
      <Grid2
        item
        xs={12}
        style={{
          backgroundColor: "#fff",
          borderRadius: "12px",
          marginBottom: "20px",
          padding: "1%",
        }}
      >
        <ShipmentFields shipmentData={shipmentData} />
      </Grid2>

      <Grid2>
        <Grid2
          item
          xs={12}
          style={{
            padding: "1%",
            backgroundColor: "#fff",
            borderRadius: "12px",
          }}
        >
          <AlertsShipmentList deviceid={deviceid} shipmentid={shipmentid} setActiveTab={setActiveTab} />
        </Grid2>
      </Grid2>
    </>
  );
};

export default AlertsContent;
